import React from 'react'

const PlayAgeStatsDisplay = ({ ageStats }) => (
  <div>
    <h3>Customers Age Group:</h3>
    <p>Adults: {ageStats.adults}</p>
    <p>Under 12 months: {ageStats.under12months}</p>
    <p>One year Olds: {ageStats.oneYearOlds}</p>
    <p>Two to three:{ageStats.twoToThree}</p>
    <p>Four and Over: {ageStats.fourAndOver}</p>
  </div>
)

export default PlayAgeStatsDisplay
